// @ts-nocheck
/* eslint-disable */

import React, { FC, useEffect } from 'react';

export const GoogleAdwords: FC = () => {
  useEffect(() => {
    window.google_conversion_id = 853779163;
    window.google_conversion_language = 'en';
    window.google_conversion_format = '3';
    window.google_conversion_color = 'ffffff';
    window.google_conversion_label = 'tiGZCMvwmXEQ28WOlwM';
    window.google_remarketing_only = false;
  }, []);
  return (
    <noscript
      dangerouslySetInnerHTML={{
        __html: `
          <div style="display:inline;">
            <img
              height="1"
              width="1"
              style="border-style:none;"
              alt=""
              src="//www.googleadservices.com/pagead/conversion/853779163/?label=tiGZCMvwmXEQ28WOlwM&amp;guid=ON&amp;script=0"
            />
          </div>
        `,
      }}
    />
  );
};
